"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function HBLogoCircle24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 26, height: 26, viewBox: "0 0 26 26", fill: "none" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_3992_91412)" },
            react_1.default.createElement("circle", { cx: 13, cy: 13, r: 13, fill: "#FFD552" }),
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9868 12.3833C19.4964 12.0676 19.7993 11.4953 19.7993 10.888C19.7993 9.80945 18.8792 9 17.2543 9H12.2555V12.496C10.4175 12.408 9.05957 12.0465 8.22057 11.5738V9.00073H6V17H8.22057V13.4858C9.56555 13.9818 10.8761 14.2342 12.2555 14.2618V17H17.0914C19.538 17 20.6641 15.944 20.6641 14.4611C20.6641 13.4385 19.9715 12.6975 18.9861 12.384L18.9868 12.3833ZM14.476 10.5738L16.8 10.5702C17.4868 10.5702 17.7093 10.8276 17.7093 11.1302C17.7093 11.7033 16.3801 12.2633 14.476 12.4145V10.5738ZM18.044 15.1578C18.2579 15.0312 18.4093 14.8829 18.4818 14.7178C18.6777 14.272 18.3691 13.725 17.8768 13.6218C17.632 13.5709 17.2352 13.5687 16.6861 13.7069C16.572 13.7357 16.4614 13.7645 16.3514 13.7931C15.8197 13.9316 15.3019 14.0664 14.4741 14.1803V15.4269H16.9122C17.2976 15.4101 17.7067 15.357 18.044 15.1578Z", fill: "#131416" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_3992_91412" },
                react_1.default.createElement("rect", { width: 26, height: 26, fill: "white" }))));
}
function HBLogoCircle24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(HBLogoCircle24Svg, Object.assign({}, svgProps)));
}
exports.default = HBLogoCircle24;
//# sourceMappingURL=HBLogoCircle24.js.map